import cN from 'classnames';
import { startsWith } from 'lodash/fp';
import * as React from 'react';
import history, { getStateForBackgroundRoute, isPageReloadScheduled } from '../../../routing/history';
import { preventJavascriptUrls } from '../../../services/security';
import { EventTrackingProps, trackEvent } from '../../services/Tracking';
import { prependAppPathToEmbbeddedWicketPages } from './service';
import styles from './style.m.less';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string;
    openInNewTab?: boolean;
    openInModal?: boolean;
    historyMethod?: 'push' | 'replace';
    hasTextStyle?: boolean;
    eventTracking?: EventTrackingProps;
}

function safeDefaultRel(href: string, target: '_blank' | string | undefined, rel: string | undefined) {
    if (!!rel || target !== '_blank') {
        return rel;
    }

    try {
        const url = new URL(href);
        const linkToMarketingWebsite =
            url.hostname === 'www.small-improvements.com' || url.hostname === 'small-improvements.com';

        return linkToMarketingWebsite ? 'noopener' : 'noopener noreferrer';
    } catch {
        return 'noopener noreferrer';
    }
}

export default class Link extends React.Component<Props> {
    render() {
        const {
            href,
            title,
            children,
            className,
            style,
            target,
            rel,
            openInNewTab,
            openInModal, // eslint-disable-line @typescript-eslint/no-unused-vars
            historyMethod = 'push',
            hasTextStyle = true,
            eventTracking,
            ...passedProps
        } = this.props;

        const t = openInNewTab ? '_blank' : target;
        const r = safeDefaultRel(href, t, rel);
        return (
            <a
                {...passedProps}
                href={preventJavascriptUrls(href)}
                className={cN(className, { [styles.reset]: !hasTextStyle })}
                style={style}
                title={title}
                onClick={e => {
                    if (eventTracking) {
                        trackEvent(eventTracking);
                    }
                    this.handleClick(e, historyMethod);
                }}
                target={t}
                rel={r}
                data-react-link
            >
                {children}
            </a>
        );
    }

    handleClick = (e: React.MouseEvent<HTMLAnchorElement>, historyMethod: 'push' | 'replace') => {
        const { onClick, openInNewTab, openInModal } = this.props;
        const href = preventJavascriptUrls(prependAppPathToEmbbeddedWicketPages(this.props.href));

        if (onClick) {
            onClick(e);
        }

        if (
            !history ||
            e.ctrlKey ||
            e.metaKey ||
            e.shiftKey ||
            e.button !== 0 ||
            openInNewTab ||
            isPageReloadScheduled()
        ) {
            return;
        }

        const isApp = startsWith('/app/', href);

        if (!isApp || e.isDefaultPrevented()) {
            return;
        }

        e.preventDefault();

        history[historyMethod](href.replace('/app', ''), openInModal ? getStateForBackgroundRoute() : undefined);
    };
}
